import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CabinPreferenceType,
  ICabinPreferenceResponseCruisesR,
} from '../../../../../interfaces/src/lib/interfaces/index';

const initialState: ICabinPreferenceResponseCruisesR = {
  cabinPreferences: [],
  secondCabinPreferences: null,
};

const cabinPreferencesSlice = createSlice({
  name: 'cabinPreferencesStore',
  initialState,
  reducers: {
    setCabinPreferences: (
      state: ICabinPreferenceResponseCruisesR,
      action: PayloadAction<CabinPreferenceType[]>
    ) => {
      state.cabinPreferences = action.payload;
    },
    setSecondCabinPreferences: (
      state: ICabinPreferenceResponseCruisesR,
      action: PayloadAction<CabinPreferenceType[]>
    ) => {
      state.secondCabinPreferences = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase('resetFromPriceType', () => {
        return initialState;
      })
      .addCase('resetFromOccupancy', () => {
        return initialState;
      })
      .addCase('resetFromCabinType', () => {
        return initialState;
      }),
});

export const { setCabinPreferences, setSecondCabinPreferences } = cabinPreferencesSlice.actions;
export default cabinPreferencesSlice.reducer;
